import { Redirect } from "react-router-dom";
import { ActionPlanListView } from "../../../amorg-common/DTOs/ActionPlanListView";
import { ActivityListingView2 } from "../../../features/activities/common/ActivityListingView";
import React from "react";

type ActionPlanListingViewProps = {
    item: ActionPlanListView;
};
export function ActionPlanListingView (props: ActionPlanListingViewProps): JSX.Element
{

    const [redirect, setRedirect] = React.useState(false);

    const pills: string[] = [];
    if (props.item.activityType === 'WorkplaceAssessment')
    {
        pills.push('Arbejdspladsvurdering');
    }
    if(props.item.activityType === 'ArticleActionPlan'){
        pills.push('Lovkrav');
    }

    return (
        <>
            {redirect &&
                <Redirect to={`/actionplans/${props.item.id}`} push={true} from={`/actionplans`} />
            }
            
            <ActivityListingView2
                title={props.item.title}
                start={props.item.start}
                end={props.item.end}
                pills={pills}
                onClick={() => setRedirect(true)}
                menuItems={[

                    props.item.topicCount === 0
                        ? { status: 'warning', icon:'warning', primaryText: 'Handleplanen har ingen emner' }
                        : { status: 'success', icon: 'fact_check', primaryText: `${props.item.topicCount} emne(r)` },

                    // Actionpoints
                    props.item.actionpointStats.total === 0
                        ? { status: 'pending', icon:'fact_check', primaryText: `Ingen handlepunkter oprettet` }
                        : props.item.actionpointStats.completed === props.item.actionpointStats.total
                            ? { status: 'success', icon:'status_ok', primaryText: `Alle handlepunkter er gennemført` }
                            :   props.item.actionpointStats.pastDeadline > 0
                                    ? { status: 'warning', icon:'warning', primaryText: `${props.item.actionpointStats.pastDeadline} handlepunkt${props.item.actionpointStats.pastDeadline > 1 ? 'er' : ''} har overskredet deadline` }
                                    : { status: 'success', icon:'fact_check', primaryText: `${props.item.actionpointStats.completed} ud af ${props.item.actionpointStats.total} handlepunkt(er) gennemført` },

                    // Owner
                    props.item.owner
                        ? { status: 'success', icon:'interface_user_user', primaryText: `${props.item.owner.fullName} valgt som ejer af handleplanen` }
                        : { status: 'warning', icon:'interface_user_user', primaryText: `Ingen ejer valgt` },

                    // 

                ]}
            />
        </>
    );
}